const TYPES_IDEAS = {
  detailsMatrix: "detailsMatrix",
  subtractions: "subtractions",
  replacements: "replacements",
  multiplications: "multiplications",
};

const FIELD_NAMES = {
  [TYPES_IDEAS.subtractions]: { idName: "idRemoteComponent" },
  [TYPES_IDEAS.replacements]: { idName: "idRemoteComponent" },
  [TYPES_IDEAS.multiplications]: { idName: "idMultiplicationComponent" },
};

export const handleSelected = (data, id) => {
  if (!data.includes(id)) {
    return [...data, id];
  }

  return data.filter((item) => item !== id);
};

const getDetailsMatrixComponent = (componentsAttributes, id, components, acc) => {
  const indexIdAttributeCol = componentsAttributes.findIndex((item) => item.id === id);
  const componentId = componentsAttributes[indexIdAttributeCol]?.componentId;
  const index = components.findIndex((component) => component.id === componentId);
  const foundedComponent = components[index];

  if (foundedComponent) {
    acc.add(foundedComponent);
  }
};

export const getFilteredComponents = (ideas, data, selectedComponents) => {
  const { components, attributes } = data;

  const componentsData = [];
  const checkedComponentsIds = [];

  for (const type in ideas) {
    if (FIELD_NAMES[type]) {
      const { idName } = FIELD_NAMES[type];

      const data = ideas[type].reduce((acc, current) => {
        const componentId = current[idName];

        if (checkedComponentsIds.includes(componentId)) {
          return acc;
        }

        if (selectedComponents.includes(componentId)) {
          const index = components.findIndex((component) => component.id === componentId);
          const foundedComponent = components[index];

          if (foundedComponent) {
            acc.add(foundedComponent);
            checkedComponentsIds.push(componentId);
          }
        }

        return acc;
      }, new Set());

      componentsData.push(...data);
    }
  }

  const componentsAttributes = attributes.reduce((acc, { id, componentId }) => {
    if (selectedComponents.includes(componentId) && !checkedComponentsIds.includes(componentId)) {
      acc.push({ id, componentId });
    }

    return acc;
  }, []);

  const componentsAttributesIds = componentsAttributes.map((attribute) => attribute.id);

  const componentsDataDetailsMatrix = ideas.detailsMatrix.reduce((acc, current) => {
    const { idAttributeCol, idAttributeRow } = current;

    if (componentsAttributesIds.includes(idAttributeCol) || componentsAttributesIds.includes(idAttributeRow)) {
      getDetailsMatrixComponent(componentsAttributes, idAttributeCol, components, acc);
      getDetailsMatrixComponent(componentsAttributes, idAttributeRow, components, acc);
    }

    return acc;
  }, new Set());

  return [...new Set([...componentsDataDetailsMatrix, ...componentsData])];
};

export const getFilteredAttributes = (ideas, attributes, selectedAttributes) => {
  const selectedAttributesData = attributes.filter((attribute) => selectedAttributes.includes(attribute.id));

  const attributesData = ideas.detailsMatrix.reduce((acc, current) => {
    const { idAttributeCol, idAttributeRow } = current;

    if (selectedAttributes.includes(idAttributeCol) || selectedAttributes.includes(idAttributeRow)) {
      const index = selectedAttributesData.findIndex(
        (attribute) => attribute.id === idAttributeCol || attribute.id === idAttributeRow,
      );

      const foundedAttribute = selectedAttributesData[index];

      if (foundedAttribute) {
        acc.add(foundedAttribute);
      }
    }

    return acc;
  }, new Set());

  return [...new Set(attributesData)];
};
